import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import { isLandingPageSurveysEnabled } from "@scenes/MessageComposition/LandingPages/hooks/useLandingPageSurveysEnabled";

const SurveysHub = lazy(() =>
  import("@scenes/Surveys/SurveysHub").then((module) => ({
    default: module.SurveysHub,
  }))
);

export const surveysHubNRO: NavigationRoutingObject = {
  Component: SurveysHub,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("surveys-sidebar-pill-menu-option", "Surveys"),
  pageNameForTracking: () => "Surveys Hub",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("surveys-sidebar-pill-menu-option-description", "View surveys across landing pages, campaigns, and Canvas"),
  icon: "nav-system-surveys",
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return (
      featureOn("surveys_hub") &&
      (isLandingPageSurveysEnabled(featureOn) || featureOn("iam_surveys") || featureOn("banner_surveys"))
    );
  },
  shouldShowTertiaryNavigationCallback: ({ featureOn }) => {
    return featureOn("surveys_hub_detail_page");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/surveys/:appGroupId",
};
